import type { ELanguage } from '../languageHelper';

import { type ITextBase, oftenUsedTranslations } from './oftenUsed';

export interface IEmployeesTexts extends ITextBase {
    activeUntil: string;
    inPlaningShort: string;
    inPlaning: string;
    firstName: string;
    lastName: string;
    description: string;
    count: string;
    empty: string;
    employees: string;
    search: string;
    allEmployees: string;
    organigramm: string;
    teamManagement: string;
    activeMembers: string;
    avgAvailability: string;
    teamMembers: string;
    employee: string;
    active: string;
    lastActive: string;
    availability: string;
    topSkills: string;
    viewProfile: string;
    viewFullTeam: string;
    userManagement: string;
    newRegistrations: string;
    totalUsers: string;
    manage: string;
}
type ILangData = {
    [lang in ELanguage]: IEmployeesTexts;
};
export const employeesTexts: ILangData = {
    th: {
        activeUntil: 'ใช้งานได้จนถึง',
        inPlaningShort: 'กระบวนการเรียนรู้',
        inPlaning: 'พนักงานกำลังวางแผนที่จะพัฒนาทักษะนี้',
        oftenUsed: oftenUsedTranslations.th,
        lastName: oftenUsedTranslations.th.lastName,
        firstName: oftenUsedTranslations.th.firstName,
        description: oftenUsedTranslations.th.description,
        employees: oftenUsedTranslations.th.employees,
        search: oftenUsedTranslations.th.search,
        allEmployees: 'พนักงานทั้งหมด',
        organigramm: 'ผังองค์กร',
        empty: oftenUsedTranslations.th.empty,
        count: oftenUsedTranslations.th.count,
        teamManagement: 'การจัดการทีม',
        activeMembers: 'สมาชิกที่ใช้งานอยู่',
        avgAvailability: 'ความพร้อมเฉลี่ย',
        teamMembers: 'สมาชิกในทีม',
        employee: 'พนักงาน',
        active: 'ใช้งานอยู่',
        lastActive: 'ใช้งานล่าสุด',
        availability: 'ความพร้อม',
        topSkills: 'ทักษะชั้นนำ',
        viewProfile: 'ดูโปรไฟล์',
        viewFullTeam: 'ดูทีมทั้งหมด',
        userManagement: 'การจัดการผู้ใช้',
        newRegistrations: 'การลงทะเบียนใหม่',
        totalUsers: 'ผู้ใช้ทั้งหมด',
        manage: 'จัดการ',
    },
    en: {
        activeUntil: 'Active until',
        inPlaningShort: 'Learning process',
        inPlaning: 'The employee is planning to acquire these skills.',
        oftenUsed: oftenUsedTranslations.en,
        lastName: oftenUsedTranslations.en.lastName,
        firstName: oftenUsedTranslations.en.firstName,
        description: oftenUsedTranslations.en.description,
        employees: oftenUsedTranslations.en.employees,
        search: oftenUsedTranslations.en.search,
        allEmployees: 'All employees',
        organigramm: 'Organization chart',
        empty: oftenUsedTranslations.en.empty,
        count: oftenUsedTranslations.en.count,
        teamManagement: 'Team Management',
        activeMembers: 'Active Members',
        avgAvailability: 'Avg Availability',
        teamMembers: 'Team Members',
        employee: 'Employee',
        active: 'Active',
        lastActive: 'Last Active',
        availability: 'Availability',
        topSkills: 'Top Skills',
        viewProfile: 'View Profile',
        viewFullTeam: 'View Full Team',
        userManagement: 'User Management',
        newRegistrations: 'New Registrations',
        totalUsers: 'Total Users',
        manage: 'Manage',
    },
    de: {
        oftenUsed: oftenUsedTranslations.de,
        lastName: oftenUsedTranslations.de.lastName,
        firstName: oftenUsedTranslations.de.firstName,
        description: oftenUsedTranslations.de.description,
        employees: oftenUsedTranslations.de.employees,
        search: oftenUsedTranslations.de.search,
        allEmployees: 'Alle Mitarbeiter',
        organigramm: 'Organigramm',
        empty: oftenUsedTranslations.de.empty,
        count: oftenUsedTranslations.de.count,
        inPlaning: 'Der Mitarbeiter plant diese Kompetenz sich zu erarbeiten.',
        inPlaningShort: 'Lernprozess',
        activeUntil: 'Aktiv bis',
        teamManagement: 'Team Verwaltung',
        activeMembers: 'Aktive Mitglieder',
        avgAvailability: 'Ø Verfügbarkeit',
        teamMembers: 'Team Mitglieder',
        employee: 'Mitarbeiter',
        active: 'Aktiv',
        lastActive: 'Zuletzt aktiv',
        availability: 'Verfügbarkeit',
        topSkills: 'Top Fähigkeiten',
        viewProfile: 'Profil anzeigen',
        viewFullTeam: 'Gesamtes Team anzeigen',
        userManagement: 'Benutzerverwaltung',
        newRegistrations: 'Neue Registrierungen',
        totalUsers: 'Gesamt Benutzer',
        manage: 'Verwalten',
    },
};
